import * as React from "react";
import CustomTag from "../custom-tag";
import Text from "../../text";
import Box from "../../box";
import { Colors } from "@blueprintjs/core";

interface IMultiSelectCustomTargetProps {
  count: number;
  text?: string;
}

const MultiSelectCustomTarget: React.FC<IMultiSelectCustomTargetProps> = ({
  count,
  text,
}) => {
  return (
    <div className="bp5-input bp5-tag-input bp5-multi-select display-flex align-center">
      <Box flexDir="row" items="center">
        <CustomTag intent={"primary"} minimal={true} bgColor={Colors.BLUE3}>
          {count}
        </CustomTag>
        <Text muted>{text || "items selected"}</Text>
      </Box>
    </div>
  );
};
export default MultiSelectCustomTarget;
